module.exports = __webpack_public_path__ + "static/media/objectsNotifications.894038c5.svg";